import { render, staticRenderFns } from "./AutotunerWidget.vue?vue&type=template&id=8f743d5c&scoped=true&"
import script from "./AutotunerWidget.vue?vue&type=script&lang=js&"
export * from "./AutotunerWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f743d5c",
  null
  
)

export default component.exports